const {default: FilesInput} = require('../FilesInput/FilesInput')

export const ImageInput = props => {
  return <FilesInput accept="image/png,image/jpeg" {...props} />
}
